import React from "react";
import HrLayout from "../../layouts/HrLayout";
import { Line, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

export default function Dashboard() {
  const attendanceData = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri"],
    datasets: [
      {
        label: "Attendance %",
        data: [95, 88, 92, 97, 90],
        borderColor: "#4F46E5",
        backgroundColor: "rgba(79,70,229,0.4)",
        tension: 0.4,
      },
    ],
  };

  const leaveData = {
    labels: ["Sick", "Casual", "Paid"],
    datasets: [
      {
        data: [4, 6, 12],
        backgroundColor: ["#EF4444", "#F59E0B", "#10B981"],
      },
    ],
  };

  return (
    <HrLayout>
      <div className="p-6 min-h-screen bg-gradient-to-b from-blue-50 to-purple-50">

        {/* HEADER */}
        <div className="mb-8 bg-gradient-to-r from-blue-600 to-purple-600 p-6 rounded-2xl shadow-lg text-white">
          <h1 className="text-3xl font-bold">HR Dashboard</h1>
          <p className="text-sm mt-1 opacity-90">
            Overview of employee performance, attendance, and HR insights.
          </p>
        </div>

        {/* TOP STAT CARDS */}
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-6 mb-8">
          {[
            { title: "Total Employees", value: "120", color: "from-blue-500 to-indigo-500" },
            { title: "Active Departments", value: "08", color: "from-green-500 to-emerald-500" },
            { title: "Pending Leaves", value: "12", color: "from-yellow-500 to-amber-500" },
            { title: "Payroll Pending", value: "03", color: "from-red-500 to-rose-500" },
          ].map((item, index) => (
            <div
              key={index}
              className={`p-5 rounded-xl text-white shadow-md bg-gradient-to-r ${item.color} hover:scale-105 transform transition cursor-pointer`}
            >
              <h2 className="text-sm opacity-90">{item.title}</h2>
              <p className="text-3xl font-bold mt-2">{item.value}</p>
            </div>
          ))}
        </div>

        {/* CHARTS */}
        <div className="grid md:grid-cols-2 gap-8 mb-10">
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <h2 className="font-semibold text-gray-700 mb-4">
              Weekly Attendance Overview
            </h2>
            <Line data={attendanceData} />
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <h2 className="font-semibold text-gray-700 mb-4">
              Leave Categories Breakdown
            </h2>
            <Doughnut data={leaveData} />
          </div>
        </div>

        {/* EXTRA STATS SECTION */}
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          HR Insights
        </h2>

        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 mb-10">
          <div className="p-5 bg-white shadow-lg rounded-xl hover:bg-blue-50 cursor-pointer">
            <h3 className="text-gray-700 font-semibold text-lg">New Joinees</h3>
            <p className="text-2xl text-blue-600 font-bold mt-2">05</p>
          </div>

          <div className="p-5 bg-white shadow-lg rounded-xl hover:bg-green-50 cursor-pointer">
            <h3 className="text-gray-700 font-semibold text-lg">Resignations</h3>
            <p className="text-2xl text-green-600 font-bold mt-2">01</p>
          </div>

          <div className="p-5 bg-white shadow-lg rounded-xl hover:bg-purple-50 cursor-pointer">
            <h3 className="text-gray-700 font-semibold text-lg">Pending Interviews</h3>
            <p className="text-2xl text-purple-600 font-bold mt-2">07</p>
          </div>
        </div>

        {/* QUICK ACTIONS */}
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Quick Actions
        </h2>

        <div className="grid md:grid-cols-4 gap-6">
          {[
            { title: "Attendance", color: "bg-blue-100 text-blue-700" },
            { title: "Departments", color: "bg-green-100 text-green-700" },
            { title: "Payroll", color: "bg-yellow-100 text-yellow-700" },
            { title: "Leaves", color: "bg-red-100 text-red-700" },
            { title: "Reports", color: "bg-purple-100 text-purple-700" },
            { title: "Recruitment", color: "bg-pink-100 text-pink-700" },
            { title: "Holidays", color: "bg-indigo-100 text-indigo-700" },
            { title: "Shifts", color: "bg-orange-100 text-orange-700" },
          ].map((item, index) => (
            <div
              key={index}
              className={`p-5 rounded-xl shadow-md hover:shadow-xl hover:scale-105 transition cursor-pointer ${item.color}`}
            >
              <h2 className="text-lg font-semibold">{item.title}</h2>
            </div>
          ))}
        </div>
      </div>
    </HrLayout>
  );
}
